import React from 'react';
import { useMutation } from '@apollo/client';
import toast from 'react-hot-toast';
import { DELETE_STOCK_TRANSACTION } from '../graphql/mutations/stockTransactions';

const StockDeleteTransactionDialog = ({ transaction, symbol, portfolioId, onClose, onDeleted }) => {
  const [deleteTransaction, { loading }] = useMutation(DELETE_STOCK_TRANSACTION);

  if (!transaction) return null;

  const handleDelete = async () => {
    try {
      const response = await deleteTransaction({
        variables: { transactionId: transaction.id, portfolioId },
      });
      const result = response.data?.deleteStockTransaction;
      if (!result?.success) throw new Error(result?.error || 'Failed to delete transaction');
      toast.success('Transaction deleted');
      onClose();
      await onDeleted?.(transaction.id);
    } catch (deleteError) {
      toast.error(deleteError.message);
    }
  };

  return (
    <div className="fixed inset-0 z-[10000] flex items-center justify-center bg-gray-900/60 px-3">
      <div className="w-full max-w-md rounded-lg bg-white p-5 shadow-xl dark:bg-gray-800">
        <h2 className="text-xl font-bold text-gray-900 dark:text-white">Delete Transaction</h2>
        <p className="mt-3 text-gray-700 dark:text-gray-300">
          Delete this {transaction.transactionType.toLowerCase().replace('_', ' ')} of {transaction.quantity} {symbol}? This cannot be undone.
        </p>
        <div className="mt-6 flex justify-end gap-2">
          <button type="button" onClick={onClose} disabled={loading} className="rounded bg-gray-200 px-4 py-2 font-semibold text-gray-700 hover:bg-gray-300 dark:bg-gray-700 dark:text-gray-200">
            Cancel
          </button>
          <button type="button" onClick={handleDelete} disabled={loading} className="rounded bg-red-600 px-4 py-2 font-semibold text-white hover:bg-red-700 disabled:opacity-60">
            {loading ? 'Deleting…' : 'Delete'}
          </button>
        </div>
      </div>
    </div>
  );
};

export default StockDeleteTransactionDialog;
